var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuoteMail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6016 0.214844H1.60156C1.18735 0.214844 0.851562 0.55063 0.851562 0.964844V13.7148C0.851562 14.5433 1.52314 15.2148 2.35156 15.2148H18.8516C19.68 15.2148 20.3516 14.5433 20.3516 13.7148V0.964844C20.3516 0.55063 20.0158 0.214844 19.6016 0.214844ZM10.6016 8.19766L3.53 1.71484H17.6731L10.6016 8.19766ZM7.85563 7.71484L2.35156 12.7595V2.67016L7.85563 7.71484ZM8.96562 8.73203L10.0906 9.76797C10.3775 10.0313 10.8181 10.0313 11.105 9.76797L12.23 8.73203L17.6675 13.7148H3.53L8.96562 8.73203ZM13.3475 7.71484L18.8516 2.66922V12.7605L13.3475 7.71484Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteMail);
export default __webpack_public_path__ + "static/media/QuoteMail.9e55331abaa19aaeb49b13f6a0900afe.svg";
export { ForwardRef as ReactComponent };